var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfigMora = function SvgConfigMora(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "config_mora_svg__Capa_2",
    viewBox: "0 0 42.34 43.69"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "config_mora_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.77 34.75a2.601 2.601 0 1 1-5.202-.002 2.601 2.601 0 0 1 5.202.002m-.88-5.24s1.71-4.45 1.71-6.89c0-1.89-1.53-3.43-3.43-3.43s-3.43 1.53-3.43 3.43c0 2.46 1.71 6.89 1.71 6.89h3.43Z",
    fill: "#ff1b51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.02 4.07h-2.43v3.27a2.4 2.4 0 0 1-2.4 2.4H29.4a2.4 2.4 0 0 1-2.4-2.4V4.07H15.37v3.27a2.4 2.4 0 0 1-2.4 2.4h-1.79a2.4 2.4 0 0 1-2.4-2.4V4.07H6.35C2.84 4.07 0 6.9 0 10.39v26.97c0 3.49 2.84 6.32 6.32 6.32h29.69c3.49 0 6.32-2.84 6.32-6.32V10.39c0-3.49-2.84-6.32-6.32-6.32Zm3.32 33.3c0 1.83-1.49 3.32-3.32 3.32H6.32C4.49 40.69 3 39.2 3 37.37V15.12h36.34v22.24Z",
    fill: "#500d76"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.57,
    height: 8.3,
    x: 10.31,
    y: 0,
    rx: 1.79,
    ry: 1.79,
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.57,
    height: 8.3,
    x: 28.59,
    y: 0,
    rx: 1.79,
    ry: 1.79,
    fill: "#19d3c5"
  }))));
};
export default SvgConfigMora;